import React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
    title?: string;
};

const TiktokIcon = ({ title, ...props }: Props) => {
    return (
        <svg
            {...props}
            width="29"
            height="32"
            viewBox="0 0 29 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
        >
            {title && <title>{title}</title>}
            <path
                d="M28.5878 13.1227C25.8356 13.1293 23.1508 12.2709 20.9128 10.669V21.8418C20.912 23.9111 20.2795 25.9309 19.0999 27.6311C17.9202 29.3312 16.2496 30.6307 14.3115 31.3558C12.3733 32.0808 10.26 32.1969 8.25411 31.6885C6.24821 31.1801 4.44533 30.0714 3.08655 28.5107C1.72776 26.95 0.877843 25.0116 0.650428 22.9548C0.423013 20.898 0.828946 18.8208 1.81395 17.001C2.79895 15.1811 4.31607 13.7053 6.16245 12.771C8.00882 11.8366 10.0964 11.4882 12.1462 11.7724V17.3919C11.2082 17.0969 10.201 17.1058 9.26841 17.4173C8.3358 17.7288 7.52548 18.3271 6.95317 19.1266C6.38085 19.9262 6.07581 20.8861 6.0816 21.8694C6.08739 22.8526 6.40372 23.8089 6.98541 24.6016C7.56711 25.3944 8.38442 25.983 9.32063 26.2836C10.2568 26.5841 11.2641 26.5811 12.1985 26.2751C13.1329 25.969 13.9467 25.3755 14.5237 24.5793C15.1007 23.7832 15.4114 22.825 15.4114 21.8418V0H20.9128C20.909 0.46458 20.9479 0.928527 21.0291 1.38598C21.2202 2.40716 21.6177 3.37861 22.1972 4.24091C22.7767 5.10321 23.526 5.83822 24.3993 6.401C25.6417 7.22251 27.0984 7.66038 28.5878 7.66006V13.1227Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default TiktokIcon;
